// Keep CSV Import profiling aligned with backend data-quality validation and
// the upload guide. Values are normalized with trim().toLowerCase() below.
const NULL_LIKE_TOKENS = new Set(['', 'null', 'n/a', 'na', 'nan', 'none', '-', '.', 'missing'])

export function isNullLike(value: string | null | undefined): boolean {
    if (value === null || value === undefined) return true
    return NULL_LIKE_TOKENS.has(value.trim().toLowerCase())
}

export interface NullStats {
    nullCount: number
    nonNullCount: number
    nullPercentage: number
}

export function computeNullStats(values: readonly (string | null | undefined)[]): NullStats {
    let nullCount = 0
    for (const v of values) {
        if (isNullLike(v)) nullCount++
    }
    const total = values.length
    const nonNullCount = total - nullCount
    const nullPercentage = total === 0 ? 0 : (nullCount / total) * 100
    return { nullCount, nonNullCount, nullPercentage }
}
